var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Back",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.338,
    height: 10.265,
    viewBox: "0 0 12.338 10.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49789",
    "data-name": "Path 49789",
    d: "M.2,46l4.456-4.456a.677.677,0,0,1,.955,0l.4.4a.67.67,0,0,1,.2.477.684.684,0,0,1-.2.483l-2.6,2.605h8.259a.659.659,0,0,1,.667.664v.572a.684.684,0,0,1-.667.693H3.384l2.629,2.62a.669.669,0,0,1,0,.948l-.4.4a.677.677,0,0,1-.955,0L.2,46.957A.681.681,0,0,1,.2,46Z",
    transform: "translate(0 -41.346)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.cfadc475a9fe885ab074e6e1662250cd.svg";
export { ForwardRef as ReactComponent };